export default __webpack_public_path__ + "static/joanna-8edea261d51f7fe74f6009f0b8fde089.png";